import TimingsJs from '@dynatrace/strato-design-tokens/timings-js';

import {
  skeletonSvgBackgroundFillCSS,
  skeletonSvgGradientCSS,
  skeletonSvgGradientRectCSS,
} from './Skeleton.sty.js';

const gradientWidth = 400;

/**
 * Renders the svg gradient used by the skeleton animations.
 * @internal
 */
export const SkeletonGradient = (props: { id: string }) => (
  <linearGradient
    className={skeletonSvgGradientCSS}
    id={props.id}
    x1="0"
    x2="1"
  >
    <stop offset="0%" stopOpacity="0.0" />
    <stop offset="50%" stopOpacity="1.0" />
    <stop offset="100%" stopOpacity="0.0" />
  </linearGradient>
);

/**
 * Renders the svg base background in skeleton animations.
 * @internal
 */
export const SkeletonBackgroundFill = () => (
  <rect className={skeletonSvgBackgroundFillCSS} />
);

/**
 * Renders the animated skeleton svg contents.
 * @internal
 */
export const SkeletonDrawer = (props: { gradientId: string }) => (
  <>
    <SkeletonBackgroundFill />

    {/* gradient */}
    <rect
      className={skeletonSvgGradientRectCSS}
      width={`${gradientWidth}px`}
      height="100%"
      fill={`url(#${props.gradientId})`}
    >
      <animate
        attributeName="x"
        from={`-${gradientWidth}px`}
        to="100%"
        dur={`${TimingsJs.Slowest.Gentle}s`}
        repeatCount="indefinite"
        keyTimes="0; 1"
        calcMode="spline"
        // this uses the Easing.FastInSlowOut values
        keySplines="0.4, 0, 0.2, 1"
      />
    </rect>
  </>
);
